import { css } from "@emotion/react";

export const formWrapperOverride = css`
  justify-content: start;
`;
